(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("slideout"));
	else if(typeof define === 'function' && define.amd)
		define("vue-slideout", ["slideout"], factory);
	else if(typeof exports === 'object')
		exports["vue-slideout"] = factory(require("slideout"));
	else
		root["vue-slideout"] = factory(root["slideout"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Slideout = __webpack_require__(1);

/* harmony default export */ __webpack_exports__["a"] = {
  data: function data() {
    return {
      slideout: null
    };
  },

  props: {
    panel: { default: '#panel' },
    menu: { default: '#menu' },
    padding: { default: 256 },
    tolerance: { default: 70 },
    touch: { default: true },
    easing: { default: 'ease' },
    side: { default: 'left' },
    duration: { default: 300 },
    toggleSelectors: {
      default: function _default() {
        return [];
      }
    }
  },
  name: 'Slideout',
  mounted: function mounted() {
    var _this = this;

    this.slideout = new Slideout({
      'panel': document.querySelector(this.panel),
      'menu': document.querySelector(this.menu),
      'padding': this.padding,
      'tolerance': this.tolerance,
      'touch': this.touch,
      'easing': this.easing,
      'side': this.side,
      'duration': this.duration
    });
    this.toggleSelectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        element.addEventListener('click', function () {
          _this.slideout.toggle();
        });
      });
    });
    var events = ['beforeclose', 'close', 'beforeopen', 'open', 'translatestart', 'translate', 'translateend'];
    events.forEach(function (event) {
      _this.slideout.on(event, function (data) {
        _this.$emit('on-' + event, data);
      });
      _this.slideout.once(event, function (data) {
        _this.$emit('once-' + event, data);
      });
    });
  },
  render: function render(h) {
    return h('div', this.$slots.default);
  }
};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_slideout_js__ = __webpack_require__(0);


var Slideout = __WEBPACK_IMPORTED_MODULE_0__components_slideout_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["default"] = Slideout;

/***/ })
/******/ ]);
});
//# sourceMappingURL=vue-slideout.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vue-slideout/lib/vue-slideout.js
// module id = Vimu
// module chunks = 0